import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';

const LOOP_AUTH_URL = process.env.REACT_APP_LOOP_AUTH_URL;

export const login = async (client_id: string, email: string, password: string): Promise<any> => {
  try {
    const base = LOOP_AUTH_URL || config.uri.auth_url;
    const path = LOOP_AUTH_URL ? '/api/client-user/login/admin' : '/authentication/login/admin';
    const uri = `${base}${path}`;

    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ client_id, email, password })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
